import React, { useCallback, useRef } from 'react';

import { JqueryClassFaker } from 'components/JqueryClassFaker';
import { sortable } from 'react/elements/sortable';
import useWavesEffect from "../../hooks/useWavesEffect";

function ChatTabComponentChatRoom(props) {
	const ref = useRef(null);
	const touchStarted = useRef(null);

	const wavesClasses = useWavesEffect(ref);
	const onTouchStart = useCallback((e) => {
		touchStarted.current = Date.now();
	}, []);

	const onTouchEnd = useCallback((e) => {
		if((Date.now() - touchStarted.current) < 300) {
			tabClick(e);
		}
	}, []);

	const tabClick = useCallback((e) => {
		e.preventDefault();
		props.chatRoom.setActive(e);
		if(props.onChatWasSelected) {
			props.onChatWasSelected(props.chatRoom);
		}
	}, [props.chatRoom]);

	const { sortable, chatRoom, disableParentSort, enableParentSort, ...otherProps } = props;
	const hasNewMentions = chatRoom.chatMessages.hasNewMentions;
	let classes = new JqueryClassFaker();
	if(chatRoom.isActive()) {
		classes.add('active');
	}
	if(chatRoom.chatMessages.hasUnreadMessages()) {
		classes.add('has_new_messages');

		if(hasNewMentions) {
			classes.add('mentioned');
		}
	}
	if(!sortable) {
		delete otherProps.sortId;
	}
	delete otherProps.onChatWasSelected;

	return (
		<a
			ref={ref}
			{...otherProps}
			onClick={tabClick}
			data-chat_room_id={chatRoom.id}
			onTouchStart={onTouchStart}
			onTouchEnd={onTouchEnd}
			onMouseEnter={disableParentSort}
			onMouseLeave={enableParentSort}
			title={chatRoom.name}
			className={`chat_tab chat_entry ${wavesClasses.toString()} ${classes.toString()}`} href={chatRoom.getUrl()}
		>
			<i className='fa fa-trophy is_ladder' />
			<span className='name'>
				<span>
				{chatRoom.name ?
					chatRoom.name :
					<span><span className='emphasized_bright'>#</span>{chatRoom.id}</span>
				}
				</span>
				{chatRoom.chatMessages.hasNewMentions &&
				<span className='mentioned badge'>!</span>
				}
			</span>
		</a>
	);
}

const SortableChatTabComponentChatRoom = sortable(ChatTabComponentChatRoom);
export { SortableChatTabComponentChatRoom, ChatTabComponentChatRoom };